// constants
import { LabSubCenterActionTypes } from './constants';
import { LabSubCenter as LabSubCenterData } from 'src/types/labSubCenter';

export type LabSubCenterActionType = {
    type:
        | LabSubCenterActionTypes.API_RESPONSE_SUCCESS
        | LabSubCenterActionTypes.API_RESPONSE_ERROR
        | LabSubCenterActionTypes.GET_LAB_SUB_CENTER
        | LabSubCenterActionTypes.ADD_LAB_SUB_CENTER
        | LabSubCenterActionTypes.EDIT_LAB_SUB_CENTER
        | LabSubCenterActionTypes.GET_LAB_SUB_CENTERS
        | LabSubCenterActionTypes.RESET
        | LabSubCenterActionTypes.RESET_SUCCESS
        | LabSubCenterActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const labSubCenterApiResponseSuccess = (
    actionType: string,
    data: LabSubCenterData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): LabSubCenterActionType => ({
    type: LabSubCenterActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const labSubCenterApiResponseError = (
    actionType: string,
    data: LabSubCenterData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): LabSubCenterActionType => ({
    type: LabSubCenterActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const addLabSubCenter = (params: any): LabSubCenterActionType => ({
    type: LabSubCenterActionTypes.ADD_LAB_SUB_CENTER,
    payload: params,
});

export const editLabSubCenter = (params: any): LabSubCenterActionType => ({
    type: LabSubCenterActionTypes.EDIT_LAB_SUB_CENTER,
    payload: params,
});

export const getLabSubCenter = (id: any): LabSubCenterActionType => ({
    type: LabSubCenterActionTypes.GET_LAB_SUB_CENTER,
    payload: { id },
});

export const getLabSubCenters = (params: any): LabSubCenterActionType => ({
    type: LabSubCenterActionTypes.GET_LAB_SUB_CENTERS,
    payload: params,
});

export const resetLabSubCenter = (): LabSubCenterActionType => ({
    type: LabSubCenterActionTypes.RESET,
    payload: {},
});

export const resetLabSubCenterSuccess = (): LabSubCenterActionType => ({
    type: LabSubCenterActionTypes.RESET_SUCCESS,
    payload: {},
});

export const resetLabSubCenterError = (): LabSubCenterActionType => ({
    type: LabSubCenterActionTypes.RESET_ERROR,
    payload: {},
});
